<template>
  <div class="containerNovelties">
    <div v-if="loading" class="text-center">
      <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else class="form-container">
      <v-form ref="form" lazy-validation class="mt-5 mx-auto col-sm-8 col-md-6">
        <div class="add-image">
          <span class="text-image">{{ $t('novelties.label.imageNovelty') }}</span>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs" v-on="on">
                <label for="file-input">
                  <v-icon dark>mdi-plus</v-icon>
                </label>
              </v-btn>
            </template>
            <span>{{ $t('label.image.text') }}</span>
            <!-- Input de tipo archivo oculto -->
            <input type="file" @change="onFileChange" id="file-input" accept="image/*" style="display: none" />
          </v-tooltip>
        </div>

        <v-text-field :label="'*'+$t('novelties.label.titleNovelty.title')" :placeholder="$t('novelties.label.titleNovelty.text')" 
          :counter="50" :maxlength="50" required :rules="rulesTitle" v-model="formData.title" color="secondary">
        </v-text-field>

        <v-textarea :label="'*'+$t('novelties.label.message.title')" :placeholder="$t('novelties.label.message.text')" 
          :counter="100" :maxlength="100" required :rules="rulesMessage" v-model="formData.message" color="secondary">
        </v-textarea>

        <v-select :label="'*'+$t('novelties.label.functionality.title')" :placeholder="$t('novelties.label.functionality.text')" 
          required :items="listFunctionalities" item-text="name" item-value="screenId" :rules="rulesFuncionality" v-model="formData.functionalityId" color="secondary">
        </v-select>

        <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" color="secondary" offset-y
          max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="formData.startDate" :label="'*'+$t('novelties.label.startDate')" color="secondary" :rules="startDateRules"
              readonly v-bind="attrs" v-on="on" disabled></v-text-field>
          </template>
          <v-date-picker v-model="localStartDate" color="primary" @change="handleStartDateChange"></v-date-picker>
        </v-menu>

        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" color="secondary" offset-y
          max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="formData.endDate" :label="'*'+$t('novelties.label.endDate')" color="secondary" :rules="endDateRules" readonly
              v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="localEndDate" color="primary" @change="handleEndDateChange"></v-date-picker>
        </v-menu>

        <v-autocomplete :label="'*'+$t('novelties.label.visibleCompanies.title')" :placeholder="$t('novelties.label.visibleCompanies.text')" 
          :rules="rulesCompany" v-model="formData.companyIds" v-if="this.roleId == 1" required multiple clearable chips
          :items="listCompanies" item-text="name" item-value="companyId" color="secondary">
          <template v-slot:item="{ item }">
            {{ item.name }} (ID:{{ item.identificationNumber }})
          </template>
        </v-autocomplete>

        <v-select :label="'*'+$t('novelties.label.status.title')" :placeholder="$t('novelties.label.status.text')"
          required :items="listStatus" item-text="nameStatus" item-value="valueStatus" :rules="rulesStatus" v-model="formData.status" color="secondary">
        </v-select>
      </v-form>
      <div class="mobile-view">
        <div v-if="formData.image" class="image-square">
          <!-- Muestra imagen seleccionada -->
          <img v-if="allowedImageTypes.includes(formData.image.type)" 
          :src="generateImageUrlPreview(formData.image)" alt="Imagen cargada" />

          <!-- Muestra imagen si lo trae el servicio -->
          <img v-else :src="formData.image" alt="Imagen cargada" />
        </div>
        <!-- Muestra imagen si NO lo trae el servicio -->
        <div v-else class="text-center">
          <p>{{ $t('label.imagePreview') }}</p>
        </div>
        <div class="mobile-text">
          <h3>{{ formData.title }}</h3>
          <p>{{ formData.message }}</p>
          <h3 v-if="formData.functionalityId" class="text-right"> 
            {{ $t('novelties.label.nextTo') }} {{ this.functionNameSelect }} <v-icon color="primary">mdi-arrow-right</v-icon>  
          </h3>
        </div>
      </div>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab fixed bottom right dark Large color="primary" @click="submitForm" v-bind="attrs"
            v-on="on"> 
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('button.update') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import {
  ACTION_GET_FUNCTIONALITIES,
  ACTION_GET_COMPANIES,
  GET_FUNCTIONALITIES,
  GET_STATE_LOADING,
  GET_COMPANIES,
  COMPANIES_M,
} from "@/views/companies/store/types/types.js";

import {
  ACTION_PUT_UPDATE_NOVELTIES,
  NOVELTIES_M,
} from "@/views/novelties/store/types/types.js";

import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

export default {
  props: {
    novelty: {
      required: true
    }
  },
  data() {
    return {
      formData: {
        newsUpdateId: this.novelty.newsUpdateId,
        image: this.novelty.imageUrl,
        title: this.novelty.title,
        message: this.novelty.message,
        functionalityId: this.novelty.functionality,
        startDate: this.novelty.startDate,
        endDate: this.novelty.endDate,
        companyIds: this.novelty.companies ? this.novelty.companies : [],
        status: this.novelty.status
      },
      functionNameSelect: null,
      listStatus: [
        {
          idStatus: 1,
          nameStatus: this.$t('novelties.label.status.option1'),
          valueStatus: true
        },
        {
          idStatus: 2,
          nameStatus: this.$t('novelties.label.status.option2'),
          valueStatus: false
        }
      ],
      allowedImageTypes: [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
      ],
      rulesTitle: [ v => !!v || this.$t('novelties.label.titleNovelty.required')],
      rulesMessage: [ v => !!v || this.$t('novelties.label.message.required')],
      rulesFuncionality: [ v => !!v || this.$t('novelties.label.functionality.required')],
      rulesCompany: [ v => !!v || this.$t('novelties.label.visibleCompanies.required')],
      rulesStatus: [ v => v != null || this.$t('novelties.label.status.required') ],
      startDateRules: [
        v => !!v || this.$t('novelties.label.startDate.required'),
      ],
      endDateRules: [
        v => !!v || this.$t('novelties.label.endDate.required'),
      ],
      menu1: false, // Para el date picker de fecha inicio
      menu2: false, // Para el date picker de fecha fin
      localStartDate: null,
      localEndDate: null,
      roleId: null
    };
  },
  async mounted() {
    await this.actionGetFunctionalities();
    this.roleId = sessionStorage.getItem('roleId');
    if (this.roleId == 1) {
      await this.actionGetCompanies();
    }
    this.dataInitial();
  },
  computed: {
    ...mapGetters({
      listFunctionalities: [`${COMPANIES_M}${GET_FUNCTIONALITIES}`],
      listCompanies: [`${COMPANIES_M}${GET_COMPANIES}`],
      loading: `${NOVELTIES_M}${GET_STATE_LOADING}`,
    }),
  },
  methods: {
    ...mapActions({
      postActionUpdateNovelties: `${NOVELTIES_M}${ACTION_PUT_UPDATE_NOVELTIES}`,
      actionGetFunctionalities: `${COMPANIES_M}${ACTION_GET_FUNCTIONALITIES}`,
      actionGetCompanies: `${COMPANIES_M}${ACTION_GET_COMPANIES}`,
    }),
    onFileChange(event) { 
      const file = event.target.files[0];
      if (!file) return;

      // Validar tipo
      if (!this.allowedImageTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.image.invalid')
        });
        return;
      }
      this.formData.image = file;
    },
    generateImageUrlPreview(file) {
      const preview = URL.createObjectURL(file);
      return preview;
    },
    handleStartDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
        console.error("Invalid date object:", date);
        return;
      }

      this.localStartDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.startDate = date;
      this.validateStartDate(modifiedDate);
      this.menu1 = false;
    },

    validateStartDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      if (selectedDate < today) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text1')
        });
        this.localStartDate = null;
        this.formData.startDate = null;
        return;
      }

      const anioActual = new Date().getFullYear();
      const anioSeleccionado = modifiedDate.getFullYear();
      if (anioSeleccionado > anioActual) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text2')
        });
        this.localStartDate = null;
        this.formData.startDate = null;
        return;
      }

      if (this.formData.endDate != null) {
        if (this.formData.startDate > this.formData.endDate) {
          Swal.fire({
            icon: "error",
            title: i18n.t('label.date.invalid'),
            text: i18n.t('label.startDate.invalid.text3')
          });
          this.localStartDate = null;
          this.formData.startDate = null;
          return;
        }
      }
    },

    handleEndDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
        console.error("Invalid date object:", date);
        return;
      }
      this.localEndDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.endDate = date;
      this.validateEndDate(this.localEndDate, modifiedDate);
      this.menu2 = false;
    },

    validateEndDate(localEndDate, modifiedDate) {
      if (localEndDate < this.localStartDate) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.endDate.invalid.text1')
        });
        this.localEndDate = null;
        this.formData.endDate = null;
        return;
      }
      const anioActual = new Date().getFullYear();
      const anioSeleccionado = modifiedDate.getFullYear();
      if (anioSeleccionado > anioActual) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.endDate.invalid.text2'),
        });
        this.localEndDate = null;
        this.formData.endDate = null;
        return;
      }
    },

    clearForm() {
      this.formData.image = '';
      this.formData.title = '';
      this.formData.message = '';
      this.formData.functionalityId = '';
      this.formData.startDate = '';
      this.formData.endDate = '';
      this.formData.companyIds = '';
      this.formData.status = '';
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join('<br>');
          Swal.fire({
            icon: 'error',
            title: i18n.t('label.errorsValidation.plural.title'),
            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });

          return;
        }

        const save = await this.postActionUpdateNovelties(this.formData);
        if (!save) {
          return Swal.fire({
            icon: 'error',
            title: i18n.t('label.invalid.title'),
            text: i18n.t('label.invalid.text')
          })
        }
        await this.clearForm();
      } catch (error) {
        console.error(i18n.t('label.failService'));
      }
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      // Validación de otros campos
      if (!this.formData.image) {
        errors.image = this.$t('novelties.label.imageNovelty');
      }

      if (!this.formData.title) {
        errors.title = this.$t('novelties.label.titleNovelty.title');
      }

      if (!this.formData.message) {
        errors.message = this.$t('novelties.label.message.title');
      }

      if (!this.formData.functionalityId) {
        errors.functionalityId = this.$t('novelties.label.functionality.title');
      }

      if (!this.formData.startDate) {
        errors.startDate = this.$t('novelties.label.startDate');
      }

      if (!this.formData.endDate) {
        errors.endDate = this.$t('novelties.label.endDate');
      }

      if (this.roleId == 1) {
        if (this.formData.companyIds.length == 0) {
          errors.companyIds = this.$t('novelties.label.visibleCompanies.title');
        }
      }

      if (this.formData.status == null) {
        errors.status = this.$t('novelties.label.status.title');
      }

      return errors;
    },
    selectedFunction(){
      const foundFunction = this.listFunctionalities.find(e => e.screenId == this.formData.functionalityId || e.name == this.formData.functionalityId );
      if (foundFunction) {
        this.functionNameSelect = foundFunction.name;
      }
    },

    dataInitial(){
      const foundFunction = this.listFunctionalities.find(e => e.name == this.formData.functionalityId );
      if (foundFunction) {
        this.formData.functionalityId = foundFunction.screenId;
        this.functionNameSelect = foundFunction.name;
      }

      if (this.roleId == 1) {
        const idCompanies = this.novelty.companies.map(e => e.companyId);
        this.formData.companyIds = idCompanies;
      }

      const foundStatus = this.listStatus.find(e => e.nameStatus == this.formData.status );
      if (foundStatus) {
        this.formData.status = foundStatus.valueStatus;
      }
    }
  },
  watch: {
    'formData.functionalityId'(newValue) {
      if (newValue) {
        this.selectedFunction();
      }
    }
  }
};
</script>

<style lang="css" scoped>
.form-container {
  display: flex;
  gap: 20px;
}

.add-image {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-image {
  color: #ff7900;
  margin-bottom: 30px;
}

.mobile-view {
  background: #ff790010;
  border-radius: 15px;
  overflow: hidden;
  width: 400px;
  min-height: 300px;
  max-height: max-content;
  margin: 0 auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.image-square img {
  width: 100%;
  max-height: 300px;
}

.mobile-text,
h3 {
  color: #6E17A5;
}

.mobile-text {
  font-family: "Amsi Pro", sans-serif;
  color: #5D6E82;
  padding: 0 20px 20px;
}

span {
  text-align: right;
}

@media screen and (max-width: 799px) {
  .form-container {
    display:block;
  }
}
</style>
